import { SvgWrapper } from "./SvgWrapper";
import { BaseIcon } from "./types";

export const MdiCheck = (props: BaseIcon) => (
  <SvgWrapper {...props}>
    <path d="M9.54961 17.9996L3.84961 12.2996L5.27461 10.8746L9.54961 15.1496L18.7246 5.97461L20.1496 7.39961L9.54961 17.9996Z" />
  </SvgWrapper>
);
